import React from 'react'

import { Form } from '@f/elements/HookForm'
import yup from '@f/elements/HookForm/validator/yup'

const HardRequest = ({ hardRequestVendors = [], ...props }) => {
  const defaultValues = hardRequestVendors.reduce(
    (values, vendor) => ({
      ...values,
      [vendor.nid]: vendor.isSelected
    }),
    {}
  )

  const vendorRules = hardRequestVendors.reduce(
    (rules, vendor) => ({
      ...rules,
      [vendor.nid]: yup.boolean()
    }),
    {}
  )

  const validationSchema = yup.object().shape(vendorRules)

  return (
    <>
      <Form.Wrapper
        mode='onChange'
        defaultValues={defaultValues}
        validationSchema={validationSchema}>
        <div className='[ f-d-flr f-m-v-020 f-t-centre ] RequestWizard-block-options-wrapper'>
          {hardRequestVendors.map(vendor => {
            const vendorNid = vendor.nid

            return (
              <Form.CheckboxWithImageLabel
                key={`hard_request_vendor_${vendorNid}`}
                name={vendorNid}
                className='[ f-d-bl f-p-t-020 f-m-a-005 f-c-fo-pri f-c-ba-whi f-c-bo-neu025 f-fl-half ]'
                labelClassNames='[ f-d-bl f-p-v-005 ]'
                theme='image-label-vendor'
                onChange={() => {
                  props.actions.handleVendorSelection(vendorNid)
                }}
                inputProps={{ 'data-sel': `hard-request-vendor-${vendorNid}` }}
                image={{
                  flexLayout: true,
                  path: vendor.logo['medium']
                }}
                wtData={{
                  checkbox: {
                    location: 'modal-hard-request',
                    values: [
                      {
                        type: 'vendor_nid',
                        value: vendorNid
                      }
                    ],
                    ...props.data.trackingInfo
                  }
                }}
              />
            )
          })}
        </div>
      </Form.Wrapper>
    </>
  )
}

export default HardRequest
